import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { getInsightSetInsights } from './insightCreators';
import { getInsightSet } from './basicCreators';

export function updateCurrentInsightSet(insightSetId, context = 'global') {
  return function(dispatch, getState) {
    if (insightSetId) {
      // Get the insightSet details
      return dispatch(getInsightSet(insightSetId))
        .then(insightSet =>
          Promise.resolve(
            dispatch({
              type: 'UPDATE_CURRENT_INSIGHTSET',
              insightSet
            })
          ).then(() => {
            dispatch(getInsightSetInsights(insightSetId, true, context));
            dispatch(getInsightSetInsights(insightSetId, false, context));
          })
        )
        .then(() => Promise.resolve());
    } else {
      dispatch(clearCurrentInsightSet());
      return Promise.reject();
    }
  };
}

export function getInsightSetSettings(insightSetId, withSettings = true) {
  return function(dispatch, getState) {
    const endpoint = '/insightset/settings';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId }
    };

    return makeAPICall(endpoint, options).then(
      response =>
        dispatch({
          type: 'UPDATE_CURRENT_INSIGHTSET_SETTINGS',
          settings: response.data
        }),
      error => dispatch(APIError(error, 'Error getting InsightSet Settings'))
    );
  };
}

export function clearCurrentInsightSet() {
  return { type: 'CLEAR_CURRENT_INSIGHTSET' };
}



// WEBPACK FOOTER //
// ./src/actions/insightSets/currentInsightSetCreators.js